import { HeroTeaser } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import { trackOnStandardError } from "../../adobeTracking/trackers";
import { useEffect } from "react";

export const NotAuthorizedPage = () => {
    const { t } = useTranslation("errors");
    const { auth } = useAuth();
    useEffect(() => {
        trackOnStandardError("Unauthorized");
    }, []);

    return (
        <>
            {auth.contractID ? (
                <HeroTeaser
                    noImage
                    buttonText={t("notAuthorized.button")}
                    onButtonClick={() => {
                        if (auth.contractID) window.location.href = "?ref_id=" + auth.contractID;
                    }}
                    sub={
                        <>
                            <p>{t("notAuthorized.subtitle")}</p>
                            <p>{t("notAuthorized.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("notAuthorized.title")}
                />
            ) : (
                <HeroTeaser
                    noImage
                    sub={
                        <>
                            <p>{t("notAuthorized.subtitle")}</p>
                            <p>{t("notAuthorized.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("notAuthorized.title")}
                />
            )}
        </>
    );
};
